import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=788b8b68&scoped=true"
import script from "./partnerList.vue?vue&type=script&lang=js"
export * from "./partnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b8b68",
  null
  
)

export default component.exports